/* ============================================================
   oollive Wellness Theme — theme.js v3
   ============================================================ */
'use strict';

var OL = OL || {};

/* ── Reveal on scroll ──────────────────────────────────────── */
OL.reveal = function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('in');
    });
  }, { threshold: 0.08 });
  els.forEach(function (el) { io.observe(el); });
};

/* ── Header scroll behaviour ───────────────────────────────── */
OL.header = function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  if (header.classList.contains('always-solid')) return;

  function update() {
    if (window.scrollY > 60) {
      header.classList.remove('transparent');
      header.classList.add('solid');
    } else {
      header.classList.remove('solid');
      header.classList.add('transparent');
    }
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
};

/* ── Cart drawer ───────────────────────────────────────────── */
OL.cart = function () {
  var drawer   = document.getElementById('cart-drawer');
  var overlay  = document.getElementById('cart-overlay');
  var openBtns = document.querySelectorAll('[data-cart-open]');
  var closeBtn = document.getElementById('cart-close');
  var keepBtn  = document.getElementById('cart-keep-shopping');
  if (!drawer) return;

  function open() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    OL.cart.refresh();
  }
  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (b) { b.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (keepBtn)  keepBtn.addEventListener('click', close);
  if (overlay)  overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* Auto-refresh count on page load */
  OL.cart.refresh();
};

OL.cart.refresh = function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count ? 'flex' : 'none';
      });
      OL.cart.renderItems(cart);
    });
};

OL.cart.renderItems = function (cart) {
  var container = document.getElementById('cart-items');
  var totalEl   = document.getElementById('cart-subtotal');
  if (!container) return;

  if (cart.item_count === 0) {
    container.innerHTML = '<div class="cart-empty"><p>O teu carrinho está vazio.</p><a href="/collections/all" class="btn-dark" style="font-size:.75rem;letter-spacing:.1em;text-transform:uppercase;padding:.75rem 1.8rem">Explorar a Loja →</a></div>';
    return;
  }

  var html = '';
  cart.items.forEach(function (item) {
    html += '<div class="cart-item">' +
      '<div class="cart-item-img"><img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy"></div>' +
      '<div class="cart-item-info">' +
        '<h4>' + item.product_title + '</h4>' +
        '<p>' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</p>' +
        '<button class="cart-item-remove" data-variant="' + item.variant_id + '">Remover</button>' +
      '</div>' +
      '<div class="cart-item-price">' + OL.formatMoney(item.line_price) + '</div>' +
    '</div>';
  });
  container.innerHTML = html;
  if (totalEl) totalEl.textContent = OL.formatMoney(cart.total_price);

  container.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      OL.cart.remove(this.dataset.variant);
    });
  });
};

OL.cart.add = function (variantId, quantity, callback) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function () {
    OL.cart.refresh();
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    if (drawer) { drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (callback) callback();
  });
};

OL.cart.remove = function (variantId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  })
  .then(function (r) { return r.json(); })
  .then(function () { OL.cart.refresh(); });
};

/* ── Product page ──────────────────────────────────────────── */
OL.product = function () {
  /* Gallery */
  var mainImg = document.getElementById('gallery-main');
  var thumbs  = document.querySelectorAll('.thumb, .g-thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      this.classList.add('active');
      if (mainImg) mainImg.src = this.dataset.src || this.src;
    });
  });

  /* Variant selector */
  var varBtns = document.querySelectorAll('.var-btn');
  var priceEl = document.getElementById('product-price');
  var priceOldEl = document.getElementById('product-price-old');
  varBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      varBtns.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var price = this.dataset.price;
      var compareAt = this.dataset.compareAt;
      if (priceEl && price) priceEl.textContent = OL.formatMoney(parseInt(price));
      if (priceOldEl) {
        priceOldEl.textContent = compareAt && compareAt !== '0' ? OL.formatMoney(parseInt(compareAt)) : '';
        priceOldEl.style.display = compareAt && compareAt !== '0' ? '' : 'none';
      }
    });
  });

  /* Add to cart */
  var addBtn = document.getElementById('add-to-cart');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var activeVar = document.querySelector('.var-btn.active');
      var variantId = activeVar ? activeVar.dataset.variantId : this.dataset.variantId;
      if (!variantId) return;
      this.textContent = 'A adicionar...';
      var self = this;
      OL.cart.add(variantId, 1, function () {
        self.textContent = '✓ Adicionado';
        setTimeout(function () { self.textContent = 'Adicionar ao carrinho'; }, 2000);
      });
    });
  }
};

/* ── Members tabs ──────────────────────────────────────────── */
OL.tabs = function () {
  var btns   = document.querySelectorAll('.tab-btn');
  var panels = document.querySelectorAll('.tab-panel');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) { b.classList.remove('active'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      this.classList.add('active');
      var panel = document.getElementById('tab-' + this.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });
};

/* ── Collection / Blog filters ─────────────────────────────── */
OL.filters = function () {
  /* Handles .filter-tab (collection), .cat-pill (blog), .filter-btn (legacy) */
  var btns = document.querySelectorAll('.filter-tab, .cat-pill, .filter-btn');
  if (!btns.length) return;
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      /* Only deactivate buttons within the same container */
      var container = this.parentElement;
      container.querySelectorAll('.filter-tab, .cat-pill, .filter-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      this.classList.add('active');
      var filter = this.dataset.filter;
      /* Filter .prod-card (collection) or .recipe-card (blog) */
      document.querySelectorAll('.prod-card, .recipe-card, .product-card-wrap, .blog-card').forEach(function (c) {
        var tags = (c.dataset.tags || '').split(',').map(function (t) { return t.trim(); });
        if (filter === 'all' || tags.indexOf(filter) > -1) {
          c.style.display = '';
        } else {
          c.style.display = 'none';
        }
      });
    });
  });
};

/* ── Cart page qty controls ────────────────────────────────── */
OL.cartPage = function () {
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      var key = qtyBtn.dataset.key;
      var numEl = qtyBtn.parentElement.querySelector('.qty-num');
      var current = parseInt(numEl ? numEl.textContent : '1');
      var next = qtyBtn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function () { location.reload(); });
    }
    var removeBtn = e.target.closest('.cart-item-remove-btn');
    if (removeBtn) {
      var key = removeBtn.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { location.reload(); });
    }
  });
};

/* ── Marquee duplicate ─────────────────────────────────────── */
OL.marquee = function () {
  var track = document.querySelector('.marquee-track');
  if (!track) return;
  track.innerHTML += track.innerHTML;
};

/* ── Newsletter form ───────────────────────────────────────── */
OL.newsletter = function () {
  var form = document.getElementById('newsletter-form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = this.querySelector('button[type=submit]');
    if (btn) { btn.textContent = 'Subscrito ✓'; btn.disabled = true; }
  });
};

/* ── Utility: format money ─────────────────────────────────── */
OL.formatMoney = function (cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
};

/* ── Init ──────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  OL.reveal();
  OL.header();
  OL.cart();
  OL.product();
  OL.tabs();
  OL.filters();
  OL.marquee();
  OL.newsletter();
  OL.cartPage();
});


